const STORAGE_KEY = 'punkmypixel_submissions';

export const getSubmissions = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
};

export const saveSubmission = (submission) => {
  const submissions = getSubmissions();
  const nextSubmission = {
    ...submission,
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString()
  };

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify([nextSubmission, ...submissions])
  );

  return nextSubmission;
};

export const removeSubmission = (id) => {
  const submissions = getSubmissions().filter((submission) => submission.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(submissions));
};